import * as React from "react"
import { Checkbox as CheckboxPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"
import { CheckIcon } from "lucide-react"

const TRADE_LOG_TABLE_CHECKBOX_CLASS =
  "!border !border-solid !border-border !bg-white transition-none data-[state=checked]:!border-[var(--brand-tropical-surf)] data-[state=checked]:!bg-[var(--brand-tropical-surf)] data-[state=checked]:!text-white data-[state=indeterminate]:!border-[var(--brand-tropical-surf)] data-[state=indeterminate]:!bg-[var(--brand-tropical-surf)] data-[state=indeterminate]:!text-white data-checked:!border-[var(--brand-tropical-surf)] data-checked:!bg-[var(--brand-tropical-surf)] data-checked:!text-white dark:!border-border dark:!bg-content-canvas dark:data-[state=checked]:!border-[var(--brand-tropical-surf)] dark:data-[state=checked]:!bg-[var(--brand-tropical-surf)] dark:data-[state=checked]:!text-white dark:data-[state=indeterminate]:!border-[var(--brand-tropical-surf)] dark:data-[state=indeterminate]:!bg-[var(--brand-tropical-surf)] dark:data-[state=indeterminate]:!text-white dark:data-checked:!border-[var(--brand-tropical-surf)] dark:data-checked:!bg-[var(--brand-tropical-surf)] dark:data-checked:!text-white"

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  const isBrokerAssetClassCheckbox = "data-broker-asset-class-checkbox" in props
  const isTradeLogTableCheckbox = "data-trade-log-table-checkbox" in props
  const isUniversityLessonCompleteCheckbox = "data-university-course-lesson-complete" in props
  const isReportsCheckbox =
    "data-reports-field-checkbox" in props || "data-reports-table-checkbox" in props
  const isNotificationsInboxCheckbox = "data-notifications-inbox-checkbox" in props
  const isAuthCheckbox = "data-auth-checkbox" in props
  const isCustomCsvAckCheckbox = "data-custom-csv-ack-checkbox" in props
  const isMarketDataConsentCheckbox = "data-market-data-consent-checkbox" in props
  const useTropicalSurfCheckbox =
    isTradeLogTableCheckbox ||
    isUniversityLessonCompleteCheckbox ||
    isReportsCheckbox ||
    isNotificationsInboxCheckbox ||
    isAuthCheckbox ||
    isCustomCsvAckCheckbox ||
    isMarketDataConsentCheckbox

  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        isBrokerAssetClassCheckbox
          ? "border-[#6b7280] bg-background data-checked:border-[#6b7280] data-checked:bg-[#6b7280] data-checked:text-white dark:bg-background dark:data-checked:bg-[#6b7280]"
          : useTropicalSurfCheckbox
            ? TRADE_LOG_TABLE_CHECKBOX_CLASS
            : cn(
                "border-input dark:bg-input/30",
                "data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
              ),
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-3.5 [&>svg]:stroke-current"
      >
        <CheckIcon
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
